window.Page = {

    listItems : document.querySelectorAll('.regesto-item'),

    // Let's launch this thing
    liftoff : () => {
        Page.expandItemOnClick()
        Page.positionImageOnMouseHover()
        Site.filterProjectsOnClick()
    },

    expandItemOnClick : () => {
        Page.listItems.forEach(item => {
            item.addEventListener('click' , (event) => {
                item.classList.toggle('item-is-expanded')
            })
        })
    },

    positionImageOnMouseHover : () => {
        Page.listItems.forEach(item => {
            item.addEventListener('mouseenter' , (event) => {

                if (window.matchMedia("(width <= 700px)").matches) return;

                // Grab the hover content container
                let hoverContent       = item.querySelector('.regesto-hover-container')
                    hoverContent.style.transform = "unset"
                let distanceToTop      = hoverContent.getBoundingClientRect().top + hoverContent.clientHeight
                let overflowingContent = distanceToTop - window.innerHeight;

                console.log(overflowingContent)

                if (overflowingContent > 0) {
                    //hoverContent.style.transform = `translateY(-${overflowingContent}px)`
                    hoverContent.style.transform = `translateY(calc(-100% - 3rem - 1px))`
                    
                }


            })
        })
    }

};

Page.liftoff()